import { VerifyEmail } from '../../../features/verify-email';

export const VerifyEmailPage = () => <VerifyEmail />;
